export const Privacy_EN_Trans={
    title:'Privacy Policy'
}

export const Privacy_DE_Trans = {
    title: 'Datenschutzrichtlinie'
};

